import React, { useState } from 'react'
import styled from 'styled-components'
import { ButtonBlue } from '../../common/ButtonsGenerics'
import { computeBalancePayment } from '../../../redux/api/account'

const BalancePayment = ({ gotoPage, selectedRequestIds = [] }) => {
    const [balancePaymentResponse, setBalancePaymentResponse] = useState(null)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handlePagarConSaldo = async () => {
        if (isSubmitting) return

        setIsSubmitting(true)
        try {
            const response = await computeBalancePayment({
                pagoSolicitudIdArr: selectedRequestIds
            })
            setBalancePaymentResponse(!response.error)
        } catch (error) {
            setBalancePaymentResponse(false)
        } finally {
            setIsSubmitting(false)
        }
    }

    const handleCerrar = () => {
        gotoPage(null)
    }

    return (
        <Container>
            <Message>Usted va a cancelar las solicitudes seleccionadas con el saldo que existe a su favor</Message>
            {balancePaymentResponse !== null && <ResultMessage success={balancePaymentResponse}>
                {balancePaymentResponse
                    ? 'Las solicitudes se han cancelado con éxito'
                    : 'Las solicitudes no han sido canceladas'}
            </ResultMessage>}
            {balancePaymentResponse !== null
                ? <ButtonBlue onClick={handleCerrar}>Cerrar</ButtonBlue>
                : <ButtonBlue disabled={isSubmitting} onClick={handlePagarConSaldo}>Aceptar</ButtonBlue>}
        </Container>
    )
}

export default BalancePayment

const Container = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 12px;
    margin: 18px 0;
`

const Message = styled.div`
    font-size: 18px;
    font-weight: bold;
`

const ResultMessage = styled.div`
    font-size: 18px;
    font-weight: bold;
    color: ${({ success }) => success ? '#4caf50' : '#e34d4b'};
`